import React from "react";

export const Features = (props) => {
  return (
    <div id="investment-philosophy" className="text-center" style={{ padding: '100px 0px' }}>
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Our Investment Philosophy</h2>
          <p>
            At Crestpeak Global, our investment philosophy centres on three principles:
          </p>
        </div>
        
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-md-4">
                  {" "}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : "Loading..."}
        </div>

        <div className="col-md-10 col-md-offset-1 section-title" style={{ marginTop: '70px', marginBottom: '0px'}}>
          <p>
            We seek investments that align with structural trends and strong governance, ensuring risk-adjusted returns and lasting impact.
          </p>
        </div>
      </div>
    </div>
  );
};
